import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './organizationSapInitialState';
import {
  _setSapContract,
  _setSapCode,
  _setSapNum,
  _setSapInstitution,
  _setSapGender,
} from './organizationSapActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationSapForm = createAsyncThunk(
  'stop/getOrganizationSapForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationSapSlice = createSlice({
  name: 'stop/organizationSapForm',
  initialState,
  reducers: {
    setSapContract: _setSapContract,
    setSapCode: _setSapCode,
    setSapNum: _setSapNum,
    setSapInstitution: _setSapInstitution,
    setSapGender: _setSapGender,
    resetOrganizationSapForm: (state) => initialState,
  },
  extraReducers: {
    [getOrganizationSapForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  setSapContract,
  setSapCode,
  setSapNum,
  setSapInstitution,
  setSapGender,
  resetOrganizationSapForm,
} = organizationSapSlice.actions;

export default organizationSapSlice.reducer;
